import styled from 'styled-components';

export const ForgetPasswordContainerStyled = styled.div`

`;
